import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezonePlugin from 'dayjs/plugin/timezone';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import 'dayjs/locale/ja';

dayjs.extend(utc);
dayjs.extend(timezonePlugin);
dayjs.extend(localizedFormat);
dayjs.extend(advancedFormat);

export const getNowTimestamp = () => Date.now();

const localeTimeFormatMapping = {
    ja: 'LL'
};

export function getLanguageFromLocale(locale) {
    const language = locale.split('-')[0];
    return (language || 'en');
}

export function getLocaleCurrencyFormat(language) {
    const format = localeTimeFormatMapping[language];
    return (format || 'DD MMM YYYY');
}

export function getLocaleDateFormat(language) {
    const format = localeTimeFormatMapping[language];
    return (format || 'MMMM Do, YYYY');
}
export const toLocalizedDateString = date => date.format('ll');

const resolveEffectiveLocale = locale => (
    locale
    || (typeof document !== 'undefined' && document.documentElement && document.documentElement.lang)
    || (typeof navigator !== 'undefined' && navigator.language)
    || Intl.DateTimeFormat().resolvedOptions().locale
    || 'en'
);

const formatWithTimezone = (localizedDate, selectedTimezone, format, fallbackFormat) => {
    try {
        return localizedDate.tz(selectedTimezone).format(format);
    } catch (error) {
        return localizedDate.format(fallbackFormat);
    }
};

export function getFormattedDateTime(dateTime, dateTimeFormat = null, selectedTimezone = null, locale = null) {
    const utcDate = dayjs.utc(dateTime);
    if (!utcDate.isValid()) {
        return '';
    }

    const effectiveLocale = resolveEffectiveLocale(locale);
    const language = getLanguageFromLocale(effectiveLocale).toLowerCase();

    // Try language locale first (for example, en-US -> en).
    const localizedDate = utcDate.locale(language);
    const format = dateTimeFormat || (selectedTimezone ? 'LLL z' : 'LL');
    const fallbackFormat = dateTimeFormat || 'LL';

    if (!selectedTimezone) {
        return localizedDate.format(format);
    }

    return formatWithTimezone(localizedDate, selectedTimezone, format, fallbackFormat);
}
